import {
  Stack,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import axios from "axios";
import {useEffect, useState} from "react";
import FormDialog from "src/components/common/FormDialog";
import UserInfo from "src/components/common/UserInfo";
import FormItem from "src/components/form-item/FormItem";
import {alert} from "src/services/alert";

const GoldVipTopupDialog = ({open, onClose, onFinish, user}) => {
  const [form, setForm] = useState({
    days: "",
    remark: "",
    password: "",
  });

  // 当 dialog 打开时重置表单
  useEffect(() => {
    if (open) {
      setForm({
        days: "",
        remark: "",
        password: "",
      });
    }
  }, [open]);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleConfirm() {
    const days = parseInt(form.days, 10);
    if (Number.isNaN(days) || days < 1 || days > 360) {
      return alert("有效天数必须在1-360天之间");
    }
    if (!form.password) {
      return alert("请输入管理员密码");
    }

    axios
      .post("/user/addGoldVip", {
        uid: user.uid,
        days,
        remark: form.remark,
        password: form.password,
      })
      .then((res) => {
        const {code, msg} = res.data;
        if (code === 1) {
          alert(msg, "success");
          onFinish();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("addGoldVip err: ", err);
        alert(err.response?.data?.msg || "操作失败");
      });
  }

  return (
    <FormDialog title="拨付金银通VIP" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <UserInfo {...user} enablePreview={false}/>
      </FormItem>

      <Alert severity="info" sx={{mb: 2}}>
        为用户开通金银通VIP会员，天数范围1-360天
      </Alert>

      <FormItem title="有效天数" required>
        <TextField
          fullWidth
          type="number"
          placeholder="请输入有效天数（1-360）"
          autoComplete="off"
          value={form.days}
          size="small"
          onChange={(e) => handleIptChange("days", e.target.value)}
          inputProps={{min: 1, max: 360}}
        />
      </FormItem>

      <FormItem title="备注">
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="请输入备注（选填）"
          autoComplete="off"
          value={form.remark}
          size="small"
          onChange={(e) => handleIptChange("remark", e.target.value)}
        />
      </FormItem>

      <FormItem title="管理员密码" required>
        <TextField
          fullWidth
          type="password"
          placeholder="请输入管理员密码"
          autoComplete="off"
          value={form.password}
          size="small"
          onChange={(e) => handleIptChange("password", e.target.value)}
        />
      </FormItem>
    </FormDialog>
  );
};

export default GoldVipTopupDialog;
